
<div class="h-100 d-flex flex-row justify-content-center fes-filter-field-config">
    <div *ngIf="!filterField.filterEditFn" class="btn-group" dropdown container="body">
        <button #menuButton dropdownToggle [title]="titles[filterField.mode]||''" class="start-menu-btn"
            [ngClass]="{'d-none': !bShowButton && modeNeedsInput}">
            <ng-container [ngSwitch]="filterField.mode">
                <ng-container *ngSwitchCase="'contains'">&cong;</ng-container>
                <ng-container *ngSwitchCase="'>='">&ge;</ng-container>
                <ng-container *ngSwitchCase="'!='">&ne;</ng-container>
                <ng-container *ngSwitchDefault>{{filterField.mode}}</ng-container>
            </ng-container>
        </button>
        <ul *dropdownMenu role="menu"
            class="p-2 dropdown-menu" style="min-width: 5rem;">
            <li role="menuitem" *ngFor="let mode of modes;" style="margin-bottom:2px;">
                <button class="btn btn-light w-100 text-left text-nowrap" style="border-radius:0;"
                    [ngClass]="{'selected-mode':mode==filterField.mode}"
                    (click)="modeSelected(mode)" [title]="titles[mode]||''">
                    {{mode}}
                </button>
            </li>
            <li *ngIf="filterField.modalEditFn" role="menuitem" style="margin-bottom:2px;">
                <button class="btn btn-light w-100 text-left text-nowrap" style="border-radius:0;"
                    (click)="filterField.modalEditFn()" title="Edit filter mode and value from a dialog">
                    <i class="fa fa-edit mr-1"></i>Edit
                </button>
            </li>
        </ul>
    </div>
    <button *ngIf="filterField.filterEditFn" #menuButton class="start-menu-btn text-secondary"
        style="padding: 2px"
        [ngClass]="{'d-none': !bShowButton && modeNeedsInput}"
        (click)="filterField.filterEditFn()"
    >
        <i class="fa fa-edit small"></i>
    </button>
    <div [ngClass]="{'d-none': !modeNeedsInput}" class="w-100">
        <ng-content></ng-content>
    </div>
</div>
